module.exports = __webpack_public_path__ + "static/media/github-file-icon.9183ac4b.svg";